import { useMemo } from 'react';
import { LegacyCartFormMessage } from '../types';

/**
 * Return whether the list of given messages indicate that any of the given field names are in an error state.
 */
const useFieldHasError = (messages: LegacyCartFormMessage[], ...fieldNames: string[]) =>
  useMemo(
    () => {
      if (messages) {
        !!fieldNames.find((fieldName) => messages?.find(({ source }) => source === 'data-' + fieldName))
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  , [messages, ...fieldNames]
  );

export default useFieldHasError;
